module.exports = __webpack_public_path__ + "img/c00_buildingtechplow_Normal_ua.dbe41a35.webp";